export default {
  title: 'Czy na pewno chcesz się wylogować?',
  buttons: {
    logout: 'Wyloguj się',
    cancel: 'Anuluj',
  },
};
